export enum LoginViewType {
  Login = 1,
  Registration = 2,
  LostPassword = 3,
}
